export const TOGGLE_CLASS_ASIDE = "TOGGLE_CLASS_ASIDE";

export const CREATE_LOG = "CREATE_LOG";
export const CREATE_LOG_SUCCESS = "CREATE_LOG_SUCCESS";
export const CREATE_LOG_FAILED = "CREATE_LOG_FAILED";

//crash
export const CRASH_API = "/CRASH_API";
export const CRASH_API_DELETE = "/CRASH_API_DELETE";
export const CRASH_API_REVIVE = "/CRASH_API_REVIVE";

export const FETCH_USER_PERMISSIONS = "FETCH_USER_PERMISSIONS";
export const FETCH_USER_PERMISSIONS_SUCCESS = "FETCH_USER_PERMISSIONS_SUCCESS";
export const FETCH_USER_PERMISSIONS_FAILED = "FETCH_USER_PERMISSIONS_FAILED";

/////////********* Toggle ASide Navigation ********************/////////////

export const TOGGLE_ASIDE_NAVIGATION = "TOGGLE_ASIDE_NAVIGATION";

export const UPDATE_FIREBASE_CONFIG = "UPDATE_FIREBASE_CONFIG";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILURE = "FETCH_COUNTRY_FAILURE";

export const FETCH_REGION_JSON = "FETCH_REGION_JSON";
export const FETCH_REGION_JSON_SUCCESS = "FETCH_REGION_JSON_SUCCESS";
export const FETCH_REGION_JSON_FAILURE = "FETCH_REGION_JSON_FAILURE";

export const FETCH_COUNTRIES_JSON = "FETCH_COUNTRIES_JSON";
export const FETCH_COUNTRIES_JSON_SUCCESS = "FETCH_COUNTRIES_JSON_SUCCESS";
export const FETCH_COUNTRIES_JSON_FAILURE = "FETCH_COUNTRIES_JSON_FAILURE";


export const FETCH_TESTIMONIAL_COUNTRIES_JSON = "FETCH_TESTIMONIAL_COUNTRIES_JSON";
export const FETCH_TESTIMONIAL_COUNTRIES_JSON_SUCCESS = "FETCH_TESTIMONIAL_COUNTRIES_JSON_SUCCESS";
export const FETCH_TESTIMONIAL_COUNTRIES_JSON_FAILURE = "FETCH_TESTIMONIAL_COUNTRIES_JSON_FAILURE";